<script setup lang="ts">
import { BadgeDollarSign, LockKeyhole } from 'lucide-vue-next'
import BrandMark from '@/components/BrandMark.vue'
import CreditPacks from '@/components/CreditPacks.vue'
const success = window.location.pathname.endsWith('/success')
</script>

<template>
  <div class="centered-gate">
    <BrandMark />
    <div class="gate-card" :class="{ 'gate-card--wide': !success }">
      <span class="gate-icon gate-icon--purple"><BadgeDollarSign :size="28" /></span>
      <span class="eyebrow">Pay for what you use</span>
      <h1>{{ success ? 'Payment received' : 'Buy credits to get started' }}</h1>
      <p v-if="success">We're confirming your payment. Your credits and your Manager activate as soon as it clears.</p>
      <p v-else>Credits pay for the work your Manager and its agents do. Before any plan runs, your Manager shows its estimated credits and waits for your approval. Larger packs include bonus credits, and credits don't expire.</p>
      <CreditPacks v-if="!success" />
      <div class="security-callout">
        <LockKeyhole :size="16" /> Payments are processed securely by Stripe. Credits are added only after payment is confirmed.
      </div>
      <RouterLink v-if="success" class="button button--dark" to="/provisioning">Check activation</RouterLink>
    </div>
  </div>
</template>
